import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { IconsModule } from "../../icons.module";
import { CommonTranslateModule } from "../../utils/common-translate.module";
import { NavigationComponent } from "./navigation.component";

@NgModule({
  declarations: [NavigationComponent],
  imports: [CommonModule, RouterModule, CommonTranslateModule, IconsModule],
  exports: [NavigationComponent],
})
export class NavigationModule {}
